import { IPartialCSS } from "partnerbuilder-common";
import { MarginStyles, PaddingStyles, WidthStyles } from "./GroupsStyles.static";

export const AppStoreStyles: IPartialCSS<true> = {
    ...WidthStyles,
    ...MarginStyles,
    ...PaddingStyles
};
